import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const COLOR_LINKS = [
  { name: 'White Screen', path: '/' },
  { name: 'Black Screen', path: '/black-screen' },
  { name: 'Red Screen', path: '/red-screen' },
  { name: 'Green Screen', path: '/green-screen' },
  { name: 'Blue Screen', path: '/blue-screen' },
  { name: 'Yellow Screen', path: '/yellow-screen' },
  { name: 'Purple Screen', path: '/purple-screen' },
  { name: 'Orange Screen', path: '/orange-screen' },
  { name: 'Pink Screen', path: '/pink-screen' },
  { name: 'White Noise', path: '/white-noise' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">⬜ White<span>Screen</span></Link>
          <p>Transform any display into a white screen workspace. Perfect for digital artists, students, and professionals who need a clean, distraction-free environment.</p>
        </div>
        <div className="footer-col">
          <h4>Tools</h4>
          <ul>{COLOR_LINKS.slice(0,5).map(l => <li key={l.path}><Link to={l.path}>{l.name}</Link></li>)}</ul>
        </div>
        <div className="footer-col">
          <h4>Product</h4>
          <ul>
            {COLOR_LINKS.slice(5).map(l => <li key={l.path}><Link to={l.path}>{l.name}</Link></li>)}
            <li><Link to="/about">About</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Support</h4>
          <ul>
            <li><Link to="/about">FAQ</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} • White Screen. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
